import axios from "@/utils/axios"



export const homscreen = async () => {
    try {
        let result = await axios.get(`${process.env.NEXT_PUBLIC_BOOKING_SERVICE}/home-screen/list`)
        if (result.status === 200) {
            return { status: true, data: result.data }
        } else {
            return { status: false, message: "Failed to fetch home screen data" }
        }
    } catch (error: any) {
        return { status: false, message: error?.message || "Something went wrong!" }
    }
}
export const countries = async () => {
    try {
        let result = await axios.get(`${process.env.NEXT_PUBLIC_MASTER_SERVICE}/master/country/list`)
        if (result.data?.status) {
            return { status: true, data: result.data?.data }
        } else {
            return { status: false, message: result?.data?.message || "Failed to fetch countries data" }
        }
    } catch (error: any) {
        return { status: false, message: error?.message || "Something went wrong!" }
    }
}
export const requestOTP = async (doc: { phn_num: string, phn_cd: string }) => {
    try {
        let result = await axios.post(`${process.env.NEXT_PUBLIC_USER_SERVICE}/auth/user/req-otp`, doc)
        if (result.data?.status) {
            return { status: true, data: result.data?.data, message: result.data?.message }
        } else {
            return { status: false, message: result?.data?.message || result?.data?.error || "" }
        }
    } catch (error: any) {
        return { status: false, message: error?.message || "Something went wrong!" }
    }
}
export const verifyOTP = async (doc: { phn_num: string, phn_cd: string, otp: string }) => {
    try {
        let result = await axios.post(`${process.env.NEXT_PUBLIC_USER_SERVICE}/auth/user/verify-otp`, doc)
        if (result.data?.status) {
            return { status: true, data: result.data?.data, message: result.data?.message }
        } else {
            return { status: false, message: result?.data?.message || result?.data?.error || "" }
        }
    } catch (error: any) {
        return { status: false, message: error?.message || "Something went wrong!" }
    }
}
export const me = async () => {
    try {
        let result = await axios.get(`${process.env.NEXT_PUBLIC_USER_SERVICE}/auth/user/me`)
        if (result.data?.status) {
            return { status: true, data: result.data?.data }
        } else {
            return { status: false, message: result?.data?.message || result?.data?.error || "" }
        }
    } catch (error: any) {
        return { status: false, message: error?.message || "Something went wrong!" }
    }
}
export const userLogout = async () => {
    try {
        let result = await axios.post(`${process.env.NEXT_PUBLIC_USER_SERVICE}/auth/user/logout`)
        if (result.data?.status) {
            return { status: true, message: result.data?.message }
        } else {
            return { status: false, message: result?.data?.message || result?.data?.error || "" }
        }
    } catch (error: any) {
        return { status: false, message: error?.message || "Something went wrong!" }
    }
}

export const fetchFilters = async (doc?: { id?: string }) => {
    try {
        let result = await axios.post(`${process.env.NEXT_PUBLIC_PRODUCT_SERVICE}/v1/product/filters`, doc)
        if (result.data?.status) {
            return { status: true, data: result.data?.data }
        } else {
            return { status: false, message: result?.data?.message || result?.data?.error || "" }
        }
    } catch (error: any) {
        return { status: false, message: error?.message || "Something went wrong!" }
    }
}
export const fetchCategoryDetails = async (params: { type: string, comp_id: string }) => {
    try {
        let result = await axios.get(`${process.env.NEXT_PUBLIC_BOOKING_SERVICE}/category/details`, {
            params: {
                type: params.type,
                comp_id: params.comp_id
            }
        })
        if (result.data?.status) {
            return { status: true, data: result.data?.data }
        } else {
            return { status: false, message: result?.data?.message, error: result?.data?.error || "" }
        }
    } catch (error: any) {
        return { status: false, error: error?.message || "Something went wrong!" }
    }
}
export const updateLanguageAndCurrency = async (lang?: string, currency?: string) => {
    try {
        let result = await axios.post(`${process.env.NEXT_PUBLIC_USER_SERVICE}/auth/user/update-language-currency`, {
            lang,
            currency
        })
        if (result.data?.status) {
            return { status: true, message: result.data?.message }
        } else {
            return { status: false, message: result?.data?.message || result?.data?.error || "" }
        }
    } catch (error: any) {
        return { status: false, message: error?.message || "Something went wrong!" }
    }
}
export const updateTranslations = async () => {
    try {
        let result = await axios.get(`${process.env.NEXT_PUBLIC_BOOKING_SERVICE}/translations/list`)
        if (result.data?.status) {
            return { status: true, data: result.data?.data, message: result.data?.message }
        } else {
            return { status: false, message: result?.data?.message || result?.data?.error || "" }
        }
    } catch (error: any) {
        return { status: false, message: error?.message || "Something went wrong!" }
    }

}
export const fetchCancels = async () => {
    try {
        let result = await axios.get(`${process.env.NEXT_PUBLIC_MASTER_SERVICE}/cancel-reason/master-list`)
        if (result.data?.status) {
            return { status: true, data: result.data?.data?.list, message: result.data?.message }
        } else {
            return { status: false, message: result?.data?.message || result?.data?.error || "" }
        }
    } catch (error: any) {
        return { status: false, message: error?.message || "Something went wrong!" }
    }
}

export const fetchReturns = async () => {
    try {
        let result = await axios.get(`${process.env.NEXT_PUBLIC_MASTER_SERVICE}/return-reason/master-list`)
        if (result.data?.status) {
            return { status: true, data: result.data?.data?.list, message: result.data?.message }
        } else {
            return { status: false, message: result?.data?.message || result?.data?.error || "" }
        }
    } catch (error: any) {
        return { status: false, message: error?.message || "Something went wrong!" }
    }
}